/**
 * Default on-chain addresses when REACT_APP_* env vars are unset (local dev only).
 * Production builds should set REACT_APP_MARKET_FACTORY_ADDRESS in Cloudflare / .env.
 * Keep in sync with frontend/.env.example and docs/ENV_VARIABLES_GUIDE.md.
 */
export const DEFAULT_MARKET_FACTORY_ADDRESS =
  '0xb5361d60262d6d4Dafa5477f4CC72ee5B2fe8e64';

export const DEFAULT_ORACLE_ADDRESS =
  '0x2E738aD5AED94d17a10b8940BE37e9f0836b741d';

export function getMarketFactoryAddress() {
  const fromEnv = (process.env.REACT_APP_MARKET_FACTORY_ADDRESS || '').trim();
  return fromEnv || DEFAULT_MARKET_FACTORY_ADDRESS;
}

export function getOracleAddress() {
  const fromEnv = (process.env.REACT_APP_ORACLE_ADDRESS || '').trim();
  return fromEnv || DEFAULT_ORACLE_ADDRESS;
}
